<div *ngIf="isLoading" class="overlay">
  <mat-progress-spinner class="spinner" mode="indeterminate">
  </mat-progress-spinner>
</div>

